// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mWmF","content":"styles_content__3Bgg-","tableWrap":"styles_tableWrap__3yA7J"};